<template>
  <div class="flex-container">
    <div class="card inset flex-grow-half">
      <h2 class="title">Mijn gegevens</h2>
      <table class="transparent-table">
        <tr>
          <td><b>Gebruikersnaam:</b></td>
          <td>{{ details.username }}</td>
        </tr>
        <tr>
          <td><b>Email:</b></td>
          <td>{{ details.email }}</td>
        </tr>
      </table>
    </div>
    <div class="card inset flex-grow-half">
      <h2 class="title">Beveiliging</h2>
      <button
        @click="$store.state.openPassword = true"
        style="width: 100%"
      >
        Wachtwoord wijzigen
      </button>
      <br /><br />
      <button
        @click="$store.state.openTwofactor = true"
        style="width: 100%"
      >
        Twee staps verificatie {{ $store.state.twoFactor ? 'verwijderen' : 'activeren' }}
      </button>
    </div>
    <div class="card inset flex-max">
      <profileActivities />
    </div>
  </div>
</template>

<script>
import profileActivities from './profile/Activities';

export default {
  name: 'profilePage',
  components: {
    profileActivities,
  },
  data() {
    return {
      details: {},
    };
  },
  created() {
    this.getUserDetails();
  },
  methods: {
    getUserDetails() {
      this.sdk.getUserDetails((response) => {
        const user = response.data[0];
        this.$store.state.twoFactor = user.two_factor === 'Aan';
        this.details = user;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
  .transparent-table {
    tr {
      background-color: transparent;
      border: none;
      td {
        padding-left: 0;
      }
    }
  }
  .flex-container > div {
    margin: 10px;
  }
</style>
